import React, { createContext, useContext } from "react";
import "../assets/css/DirectoryLeadership.css";

const CoupleRoleContext = createContext<string | null>(null);

type DirectoryLeadershipInfoProps = {
  name: React.ReactNode;
  hisMobile?: string | null;
  hisEmail?: string | null;
  herMobile?: string | null;
  herEmail?: string | null;
  anniversary?: string | null;
  showPersonLabels?: boolean;
  onNameClick?: () => void;
  nameTitle?: string;
};

export function DirectoryLeadershipHeading({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  return (
    <div className={`dir-lead-heading-wrap${className ? ` ${className}` : ""}`}>
      <span className="dir-lead-heading-line" aria-hidden="true" />
      <h2 className="LeadHeading dir-lead-heading">{title}</h2>
      <span className="dir-lead-heading-line" aria-hidden="true" />
    </div>
  );
}

export function DirectoryCoupleEntry({
  role,
  children,
}: {
  role?: string | null;
  children: React.ReactNode;
}) {
  const child = React.Children.only(children) as React.ReactElement<{
    className?: string;
  }>;

  return (
    <CoupleRoleContext.Provider value={role || null}>
      {React.cloneElement(child, {
        className: `${child.props.className || ""} dir-couple-row`.trim(),
      })}
    </CoupleRoleContext.Provider>
  );
}

function ContactLine({
  label,
  phone,
  email,
}: {
  label?: string | null;
  phone?: string;
  email?: string;
}) {
  if (!phone && !email) return null;
  return (
    <p className="dir-lead-line">
      {label ? <span className="dir-lead-line-label">{label} </span> : null}
      {phone ? <span>{phone}</span> : null}
      {phone && email ? <span className="dir-lead-dot"> · </span> : null}
      {email ? <span className="dir-lead-email">{email}</span> : null}
    </p>
  );
}

export default function DirectoryLeadershipInfo({
  name,
  hisMobile,
  hisEmail,
  herMobile,
  herEmail,
  anniversary,
  showPersonLabels = true,
  onNameClick,
  nameTitle,
}: DirectoryLeadershipInfoProps) {
  const role = useContext(CoupleRoleContext);
  const hisPhone = (hisMobile || "").trim();
  const hisMail = (hisEmail || "").trim();
  const herPhone = (herMobile || "").trim();
  const herMail = (herEmail || "").trim();
  const hasHis = Boolean(hisPhone || hisMail);
  const hasHers = Boolean(herPhone || herMail);

  return (
    <div className="dir-lead-info">
      {role ? <div className="dir-lead-role">{role}</div> : null}
      <h2
        className={`dir-lead-name${onNameClick ? " dir-lead-name--clickable" : ""}`}
        onClick={onNameClick}
        title={nameTitle}
        style={onNameClick ? { cursor: "pointer" } : undefined}
      >
        {name}
      </h2>
      {hasHis || hasHers || anniversary ? (
        <div className="dir-lead-meta">
          <ContactLine
            label={showPersonLabels ? "His:" : null}
            phone={hisPhone}
            email={hisMail}
          />
          <ContactLine
            label={showPersonLabels ? "Hers:" : null}
            phone={herPhone}
            email={herMail}
          />
          {anniversary ? (
            <p className="dir-lead-line">
              <span className="dir-lead-line-label">Anniversary Date: </span>
              <span>{anniversary}</span>
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
